import { createClient } from '@supabase/supabase-js';

/**
 * =============================================
 * SUPABASE CLIENT CONFIGURATION
 * =============================================
 * CRITICAL: This file establishes the connection to your Supabase backend.
 * 
 * ENVIRONMENT SETUP REQUIREMENTS:
 * 1. Create a .env.local file in the project root
 * 2. Add these variables to .env.local:
 *    - REACT_APP_SUPABASE_URL=your_project_url
 *    - REACT_APP_SUPABASE_ANON_KEY=your_anon_key
 * 3. Restart the development server after changes
 * 
 * DO NOT:
 * - Hard-code Supabase credentials
 * - Remove the environment variable validation
 * - Include service role keys in client code
 */

// Use environment variables for Supabase URL and key
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// CRITICAL: Validates that required environment variables are set
// This prevents runtime errors due to missing configuration
if (!supabaseUrl || !supabaseKey) {
  console.error('\n*** SUPABASE ENV VARIABLES ARE MISSING! ***\n');
  console.error('Please ensure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are set in your .env.local file and the development server was restarted.\n');
  // Optionally throw an error or return a dummy client to prevent further issues
  // throw new Error("Supabase environment variables not set.");
}

// Create the supabase client
// SECURITY: Uses the public anon key only, never the service key
const supabase = createClient(supabaseUrl, supabaseKey);

// Export both ways for backward compatibility
// RECOMMENDED: Use default export in new code
export const supabaseClient = supabase;
export default supabase;

// IMPORTANT: Always import supabase using the default import:
//   import supabase from '../services/supabase';
// Do NOT use named imports like { supabase } – only the default is exported. 